import subModuleKeys from '@/modules/constants/subModuleKeys';

const RecieptPrinterModule = () => import(/* webpackChunkName: "recieptprinter" */ '@/components/modules/boxoffice/RecieptPrinterModule.vue');
const IntegrationsModule = () => import(/* webpackChunkName: "usersettingsedit" */ '@/components/modules/boxoffice/IntegrationsModule.vue');

const subModules = {
  [subModuleKeys.RECIEPT_PRINER]: {
    name: subModuleKeys.RECIEPT_PRINER,
    component: RecieptPrinterModule,
    path: '/boxoffice/recieptprinter',
    props: { moduleKey: subModuleKeys.RECIEPT_PRINER },
  },
  [subModuleKeys.INTEGRATIONS]: {
    name: subModuleKeys.INTEGRATIONS,
    component: IntegrationsModule,
    path: '/boxoffice/integrations',
    props: { moduleKey: subModuleKeys.INTEGRATIONS },
  },
};

export default subModules;
